<p-tabView>
  <p-tabPanel (click)="detectTabClick($event)" *ngFor="let header of headers" [header]="header.name">
    <ng-template pTemplate="content">
      <div [innerHTML]="header.content"></div>
    </ng-template>
  </p-tabPanel>
</p-tabView>